export const PRINT_MESSAGES = (intl) => ({
  default: intl.formatMessage({
    id: 'printMessageDefault',
  }),
  success: intl.formatMessage({
    id: 'printMessageSuccess',
  }),
  error: intl.formatMessage({
    id: 'printMessageError',
  }),
})

export const CANCEL_PRINT_MESSAGES = (intl) => ({
  default: intl.formatMessage({
    id: 'cancelPrintMessageDefault',
  }),
  success: intl.formatMessage({
    id: 'cancelPrintMessageSuccess',
  }),
  error: intl.formatMessage({
    id: 'cancelPrintMessageError',
  }),
})

export const FISCAL_CODE_MESSAGES = (intl) => ({
  default: intl.formatMessage({
    id: 'fiscalCodeMessageDefault',
  }),
  success: intl.formatMessage({
    id: 'fiscalCodeMessageSuccess',
  }),
  error: intl.formatMessage({
    id: 'fiscalCodeMessageError',
  }),
})
